<template>
  <div class="app dashboard">
    <div class="page-wrapper"><router-view /></div>
    <v-card v-if="loading">
      <div class="fakeLoader">
        <div class="fl fl-spinner spinner4"></div>
      </div>
    </v-card>
  </div>
</template>

<script>
export default {
  data () {
    return {
      loading: false
    }
  },
  async mounted () {
    this.$eventBus.$on('SHOW_PROGRESS_CIRCLE', () => {
      if (!this.loading) {
        this.loading = true
      }
    })
    this.$eventBus.$on('HIDE_PROGRESS_CIRCLE', () => {
      this.loading = false
    })
  }
}
</script>

<style lang="sass" scoped>
.page-wrapper
  min-height: calc(100vh - 64px - 50px - 42px)
</style>
